import { isValidCssColor } from "./colorFormatUtils";

export const validHex = (value: string): boolean => {
  return isValidCssColor(value);
};
